export const getState = (state = {}) => state;
export const getConfig = state => getState(state).authConfig;
export const getProfile = state => getState(state).profile;
